(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2291],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 50502:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-projekte",
      function () {
        return __webpack_require__(40174);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1887);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39321);




var Head = function(param) {
    var title = param.title, description = param.description, url = param.url, imageUrl = param.imageUrl, imageAlt = param.imageAlt, noIndex = param.noIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "Street of Code"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:site",
                content: "@StreetofCode1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:locale",
                content: "sk_SK"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: imageUrl || _constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOGO_IMAGE_URL */ .PX
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: imageAlt || title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "google-site-verification",
                content: "FB24EUCOSSYhz39LdPTSNW4Yebc0El71AV7luRQcQQc"
            }),
            noIndex && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 47274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: center;\n  position: relative;\n  margin-top: 6em;\n  width: 30px !important;\n  height: 70px !important;\n  border-radius: 22px;\n  border: 4px solid var(--color-accent);\n\n  :hover {\n    cursor: pointer;\n  }\n\n  ::after {\n    position: absolute;\n    content: '';\n    display: block;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background-color: var(--color-accent);\n    top: 43px;\n    left: 2px;\n\n    animation: ",
        " 2.5s linear infinite;\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var VerticalSlider = function(param) {
    var innerRef = param.innerRef;
    var handleVerticalSliderClick = function() {
        if (innerRef.current) {
            innerRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Slider, {
        ref: innerRef,
        onClick: handleVerticalSliderClick
    });
};
var verticalSliderAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .keyframes */ .F4)({
    "0%": {
        top: 43
    },
    "50%": {
        top: 2
    },
    "100%": {
        top: 43
    }
});
var Slider = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7bd27357-0"
})(_templateObject(), verticalSliderAnimation, _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.S */ .U.S);
/* harmony default export */ __webpack_exports__["Z"] = (VerticalSlider);


/***/ }),

/***/ 40174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41246);
/* harmony import */ var _components_NavBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55270);
/* harmony import */ var _components_core_Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96169);
/* harmony import */ var _components_core_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90656);
/* harmony import */ var _components_core_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43195);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81990);
/* harmony import */ var _components_domain_user_UserAvatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40592);
/* harmony import */ var _components_VerticalSlider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47274);
/* harmony import */ var _images__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91195);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26221);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80371);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  span {\n    max-width: 750px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  align-self: center;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  margin-left: 16px;\n  padding: 0;\n\n  li {\n    margin: 6px;\n    padding: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid var(--color-secondary) !important;\n  border-radius: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















// Links
var UcimeSaOOP = "https://www.youtube.com/playlist?list=PL5Od02qMtU8iA1ypGekw_3Ry_YluVJD5I";
var PodcastKracko = "https://www.youtube.com/watch?v=S2mtVgxNC_I";
var FirstVideoPodcast = "https://www.youtube.com/watch?v=DrGCl0LoNIU";
var Informatika101 = "https://www.youtube.com/playlist?list=PL5Od02qMtU8j4Evu2H-eHSXuNSVlfrhcx";
var Patreon = "https://www.patreon.com/streetofcode";
var ProjectPage = function() {
    var storyStartRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var renderLink = function(text, src) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(StyledLink, {
            href: src,
            target: "_blank",
            children: text
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_Head__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "O projekte | Street of Code",
                description: "Nauč sa s nami programovať!",
                url: (0,_routes__WEBPACK_IMPORTED_MODULE_13__/* .prefixWithHost */ .O)(_routes__WEBPACK_IMPORTED_MODULE_13__/* .routes.oProjekte */ ._.oProjekte)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_NavBar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(StyledPagedContentWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    direction: "column",
                    gap: "48px",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    align: "center",
                                    variant: "h3",
                                    children: "Čo je to Street of Code?"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    align: "center",
                                    children: "Na Street of Code sa m\xf4žeš vzdel\xe1vať o programovan\xed. Tvor\xedme podcast o programovan\xed, kurzy a vide\xe1 najm\xe4 pre zač\xednaj\xfacich program\xe1torov. Street of Code založili dvaja full-time program\xe1tori, ktor\xed sa rozhodli, že by chceli okrem pr\xe1ce robiť aj niečo navyše. Niečo, čo by mohlo pom\xf4cť in\xfdm ľudom na ich program\xe1torskej ceste."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h4",
                                    children: "Zakladatelia"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(AvatarsFlexWrapper, {
                                    justifyContent: "space-between",
                                    gap: "32px",
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            direction: "column",
                                            gap: "16px",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_domain_user_UserAvatar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    sizePx: 200,
                                                    src: _images__WEBPACK_IMPORTED_MODULE_11__/* .Jakub */ .Z7,
                                                    name: "Jakub Jahič",
                                                    priority: true,
                                                    placeholder: true
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    size: "small",
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                                            children: "Jakub (29)."
                                                        }),
                                                        " Bav\xed ma filozofovať o programovan\xed a o živote. R\xe1d pom\xe1ham zač\xednaj\xfacim program\xe1torom a vytv\xe1ram kurzy."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            direction: "column",
                                            gap: "16px",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_domain_user_UserAvatar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    sizePx: 200,
                                                    src: _images__WEBPACK_IMPORTED_MODULE_11__/* .Gabriel */ .PC,
                                                    name: "Gabriel Kerekeš",
                                                    priority: true,
                                                    placeholder: true
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    size: "small",
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("b", {
                                                            children: "Gabriel (28)."
                                                        }),
                                                        " Programovanie ma bav\xed. Podobne ma bav\xed aj odovzd\xe1vanie sk\xfasenost\xed. Popri tom sa snaž\xedm aj dostatočne h\xfdbať a tr\xe1viť veľa času s rozrastaj\xfacou sa rodinou."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_VerticalSlider__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    innerRef: storyStartRef
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
                            ref: storyStartRef,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                direction: "column",
                                gap: "16px",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                        variant: "h4",
                                        children: "Ako to cel\xe9 začalo? (2018)"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: "V roku 2018 sme dokončili št\xfadium aplikovanej informatiky na FEI STU. Už počas školy (najm\xe4 cez pr\xe1zdniny) sme sa pok\xfašali viackr\xe1t vytvoriť nejak\xfd projekt, mobiln\xfa appku alebo niečo podobn\xe9. Na začiatku školsk\xe9ho roka sme na projekt už buď nemali čas, alebo ten projekt s\xe1m o sebe ani vlastne nebol dostatočne zauj\xedmav\xfd."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        direction: "column",
                                        alignSelf: "center",
                                        alignItems: "center",
                                        gap: "8px",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: _images__WEBPACK_IMPORTED_MODULE_11__/* .FirstPodcast */ .gl,
                                                width: "512",
                                                height: "316",
                                                alt: "Prv\xfd podcast",
                                                lazyBoundary: "400px"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "very-small",
                                                children: "Nat\xe1čanie prv\xfdch podcastov (2018)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: "V lete 2018 však prišiel n\xe1pad vytvoriť podcast. V tom čase na Slovensku neboli žiadne podcasty o programovan\xed (alebo aspoň sme o nich nevedeli). Celkovo podcasty neboli ešte tak\xe9 rozš\xedren\xe9, ako je tomu dnes."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: "Mali sme za sebou vysok\xfa školu a prv\xe9 roky praxe, o čom sa dalo veľa kecať, tak sme to sk\xfasili. Ohlasy neboli veľk\xe9, ale n\xe1s to bavilo a st\xe1le sme r\xe1stli. Vtedy sme ešte netušili, či n\xe1m to vydrž\xed a už duplom sme netušili, že okrem podcastov budeme robiť aj niečov viac."
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        children: "Btw ak ti pr\xedde n\xe1š n\xe1zov Street of Code divn\xfd, tak aj nad t\xfdmito n\xe1zvami sme uvažovali:"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(OtherNamesGrid, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Objektovo orientovan\xfd"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Bin\xe1rny podcast"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Jednotky a Nulky"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Ify a Elsy"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Na bin\xe1rnej vlne"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Poctiv\xfd k\xf3d"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Čist\xe9 k\xf3dy"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "K\xf3d je život"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Republika K\xf3du"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "K\xf3dovinky"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Bodkočiarka"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Sn\xedvam v k\xf3doch"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "K\xf3dy z vody"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Riadky k\xf3du"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                size: "small",
                                                children: "Bin\xe1rny svet"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h4",
                                    children: "Ako to prebiehalo? (2019-2022)"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: [
                                        "Epiz\xf3dy sme nahr\xe1vali každ\xe9 dva t\xfdždne. Dĺžka a kvalita sa (d\xfafajme) st\xe1le zvyšovala. Vytvorili sme Wordpress str\xe1nku a podcast sme uploadovali na ",
                                        renderLink("Spotify", _routes__WEBPACK_IMPORTED_MODULE_13__/* .routes.spotify */ ._.spotify),
                                        ". Nesk\xf4r sme si založili ",
                                        renderLink("YouTube", _routes__WEBPACK_IMPORTED_MODULE_13__/* .routes.youtube */ ._.youtube),
                                        " ",
                                        "kan\xe1l, kam sme tiež epiz\xf3dy uploadovali."
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: [
                                        "V prvom roku sme sa snažili p\xedsať aj čl\xe1nky. Dokonca naše prv\xe9 čl\xe1nky boli po anglicky, lebo sme ešte nevedeli, či ich chceme mať po anglicky alebo slovensky. Prv\xe9 program\xe1torsk\xe9 vide\xe1 (",
                                        renderLink("Uč\xedme sa OOP - Kalkulačka", UcimeSaOOP),
                                        ") sme nahrali v j\xfani 2019."
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "V roku 2019 sme z\xe1roveň obaja začali pracovať full-time, na čo sme si museli zvykn\xfať."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h5",
                                    children: "Prelomov\xfd rok 2020"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "V tomto roku sme mali niekoľko v\xfdznamn\xfdch miľln\xedkov:"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(StyledUL, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("li", {
                                                children: [
                                                    "Prv\xfd ",
                                                    renderLink("podcast", FirstVideoPodcast),
                                                    ", v ktor\xe9 malo video form\xe1t. Doteraz sme nahr\xe1vali iba audio."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("li", {
                                                children: [
                                                    "Prv\xfd ",
                                                    renderLink("podcast", PodcastKracko),
                                                    " s hosťom (Jakub Kracina, Št\xfadium v Brne vs. v Bratislave)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                children: "Prv\xfd code retreat (Myjava), z čoho sa stala trad\xedcia. Code retreat je v\xfdlet, na ktorom programujeme a prem\xfdšľame o našich v\xedziach, cieľoch a zmysle života."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                children: "N\xe1pad a vytvorenie projektu “Kurzov\xe1 platforma” (čo je vlastne t\xe1to str\xe1nka). P\xe1čil sa n\xe1m n\xe1pad mať vlastn\xfa str\xe1nku s našimi kurzami. Brainstormovali sme, ako by to mohlo vyzerať, navrhli sme datab\xe1zu, zvolili sme technol\xf3gie (React + Kotlin Spring Boot) a vytvorili projekt."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("li", {
                                                children: [
                                                    "Prv\xfd kurz ",
                                                    renderLink("Informatika 101", Informatika101),
                                                    " - ktor\xfd sme zavesili na YouTube."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                children: "Vytvorili sme si pl\xe1n, ktor\xfd chceme dosiahnuť. Na v\xfdsledok (ale nie cel\xfd) sa pr\xe1ve pozer\xe1š."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                children: "Viedli sme kr\xfažok na strednej škole, kde sme učili Python. Tu sme spoznali Ivana, ktor\xfd n\xe1m potom aj pom\xe1hal vo v\xfdvoji tejto webstr\xe1nky či zlepšoval discord bota. Bol naš\xedm st\xe1žistom, až pokiaľ ho nedobehli in\xe9 povinnosti."
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("li", {
                                                children: [
                                                    "Vytvorili sme ",
                                                    renderLink("Discord", _routes__WEBPACK_IMPORTED_MODULE_13__/* .routes.discord */ ._.discord),
                                                    " kan\xe1l a začali vytv\xe1rať komunitu."
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    direction: "column",
                                    alignSelf: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: _images__WEBPACK_IMPORTED_MODULE_11__/* .ProjectMockup */ .FA,
                                            width: "348",
                                            height: "495",
                                            alt: "N\xe1vrh webstr\xe1nky",
                                            lazyBoundary: "400px"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            size: "very-small",
                                            children: "N\xe1vrh kurzovej platformy (2020)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "V roku 2021 a 2022 sme začali do našich podcastov pravidelne poz\xfdvať r\xf4znych hosťov. Vždy bolo našim cieľom, aby bol podcast poučn\xfd pre zač\xednaj\xfacich program\xe1torov, a z\xe1roveň aj dostatočne zauj\xedmav\xfd pre t\xfdch sk\xfasenejš\xedch. Taktiež sme experimentovali s nov\xfdm typom obsahu, ako napr. streamy na YouTube či r\xf4zne vide\xe1."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "Projekt kurzov\xe1 platforma a samotn\xe9 vytv\xe1ranie kurzov bol oveľa v\xe4čš\xed challenge, ako sme si spočiatku mysleli. Hoci sme urobili prv\xfa verziu str\xe1nky r\xfdchlo, uvedomili sme si, že nie je v\xf4bec vizu\xe1lne pr\xedťažliv\xe1 a potrebujeme niečo lepšie. Na obr\xe1zkoch nižšie hneď uvid\xedš prečo."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    direction: "column",
                                    alignSelf: "center",
                                    gap: "48px",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            direction: "column",
                                            alignSelf: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(BorderedImage, {
                                                    src: _images__WEBPACK_IMPORTED_MODULE_11__/* .FirstDesignHome */ .Q5,
                                                    width: "480",
                                                    height: "270",
                                                    alt: "N\xe1vrh webstr\xe1nky",
                                                    lazyBoundary: "400px"
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    size: "very-small",
                                                    children: "Prv\xe1 nak\xf3den\xe1 verzia - \xfavodn\xe1 str\xe1nka"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            direction: "column",
                                            alignSelf: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(BorderedImage, {
                                                    src: _images__WEBPACK_IMPORTED_MODULE_11__/* .FirstDesignCourseDetail */ .q9,
                                                    width: "480",
                                                    height: "322",
                                                    alt: "N\xe1vrh webstr\xe1nky",
                                                    lazyBoundary: "400px"
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    size: "very-small",
                                                    children: "Prv\xe1 nak\xf3den\xe1 verzia - detail kurzu"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            direction: "column",
                                            alignSelf: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(BorderedImage, {
                                                    src: _images__WEBPACK_IMPORTED_MODULE_11__/* .FirstDesignTakeCoursePage */ ._T,
                                                    width: "480",
                                                    height: "445",
                                                    alt: "N\xe1vrh webstr\xe1nky",
                                                    lazyBoundary: "400px"
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    size: "very-small",
                                                    children: "Prv\xe1 nak\xf3den\xe1 verzia - robenie kurzu"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "Cel\xfd projekt sme zahodili a začali odznova. Učili sme sa dizajn a frontend. Spravili sme si dizajnov\xfd n\xe1vrh str\xe1nky, ktor\xfd sme aspoň 10x prerobili. Iterovali sme, k\xfdm sme neboli spokojn\xed."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "V roku 2021 prišli r\xf4zne životn\xe9 zmeny, ako napr. Jakubova svadba či Gabovo dieťa Kubko. Museli sme sa adaptovať a času bolo st\xe1le menej."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "V roku 2022 sme sa však poriadne hecli a dokončili t\xfato webstr\xe1nku a konečne spustili naše kurzy. Čak\xe1 n\xe1s ešte veľa roboty, ale st\xe1le n\xe1s to bav\xed a napĺňa a veľmi sa teš\xedme."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h4",
                                    children: "Ak\xe9 s\xfa naše ciele? (2023 - )"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: [
                                        "Našich cieľov je st\xe1le viac a viac. Medzi ne m\xf4žeme zaradiť:",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(StyledUL, {
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                    children: "Pravideľne prid\xe1vať nov\xe9 kurzy."
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("li", {
                                                    children: [
                                                        "Obohacovať t\xfato str\xe1nku o nov\xe9 funkcie. Eventu\xe1lne by sme chceli, aby sa dalo na tejto str\xe1nke aj priamo programovať (možno niečo podobn\xe9 ako m\xe1",
                                                        " ",
                                                        renderLink("Scrimba", "https://scrimba.com/"),
                                                        ")."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                    children: "Vytvoriť ak\xfasi Roadmapu pre zač\xednaj\xfaceho program\xe1tora. N\xe1vod, ako začať programovať a ako n\xe1sledne pokračovať. Vyznačiť r\xf4zne možnosti, ktor\xe9 bud\xfa obsahovať zdroje, kde sa to d\xe1 naučiť."
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                    children: "Zv\xe4čšovať komunitu, prep\xe1jať ľud\xed s podobn\xfdmi cieľmi, aby si navz\xe1jom pom\xe1hali."
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                    children: "Online workshopy"
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("li", {
                                                    children: "Robiť predn\xe1šky (či už na vysok\xfdch škol\xe1ch alebo konferenci\xe1ch)"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h4",
                                    children: "Ako n\xe1š m\xf4žeš podporiť?"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: [
                                        "Podporiť n\xe1s m\xf4žeš na ",
                                        renderLink("Patreone", Patreon),
                                        ". Budeme ti veľmi vďačn\xed."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            direction: "column",
                            gap: "16px",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(AlignedHeading, {
                                    variant: "h4",
                                    children: "Spolupr\xe1ca"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_components_core_Text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    children: "Spolupr\xe1cu v\xedtame. Nap\xedš n\xe1m tvoj n\xe1pad a určite sa ozveme. Ak by si n\xe1m n\xe1hodou vedel alebo vedela pom\xf4cť s dot\xe1ciami, tak by sme ti boli veľmi vďačn\xed. M\xe1me vytvoren\xe9 občianske združenie."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)("a").withConfig({
    componentId: "sc-3adcd32e-0"
})(_templateObject());
var StyledPagedContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3adcd32e-1"
})(_templateObject1());
var OtherNamesGrid = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3adcd32e-2"
})(_templateObject2());
var StyledUL = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-3adcd32e-3"
})(_templateObject3());
var BorderedImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_2___default())).withConfig({
    componentId: "sc-3adcd32e-4"
})(_templateObject4());
var AlignedHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_components_core_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3adcd32e-5"
})(_templateObject5());
var AvatarsFlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3adcd32e-6"
})(_templateObject6(), _theme_device__WEBPACK_IMPORTED_MODULE_9__/* .device.S */ .U.S);
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProjectPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,9774,2888,179], function() { return __webpack_exec__(50502); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);